var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrainImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5696 15.9185C51.0711 17.1309 48.9291 17.1309 47.4306 15.9185C44.1555 13.3049 39.7721 12.5457 35.8088 13.9057C31.8455 15.2657 28.8518 18.5564 27.8715 22.6302C27.5248 24.2153 26.2838 25.4515 24.6974 25.792C20.0338 26.7386 16.1467 29.9434 14.3285 34.3411C12.5103 38.7387 12.9992 43.7528 15.6327 47.7164C16.5817 49.1058 16.5817 50.9349 15.6327 52.3243C12.9992 56.2879 12.5103 61.302 14.3285 65.6997C16.1467 70.0973 20.0338 73.3022 24.6974 74.2487C26.2838 74.5892 27.5248 75.8255 27.8715 77.4105C28.8571 81.4808 31.853 84.766 35.8155 86.1216C39.778 87.4772 44.1584 86.7155 47.4306 84.1018C48.9291 82.8894 51.0711 82.8894 52.5696 84.1018C55.8475 86.7154 60.234 87.472 64.1981 86.1076C68.1622 84.7432 71.1538 81.4471 72.1288 77.3697C72.4754 75.7846 73.7164 74.5484 75.3028 74.2079C79.9671 73.2608 83.8542 70.0548 85.6718 65.6561C87.4893 61.2574 86.9988 56.2426 84.3634 52.2794C83.4182 50.8918 83.4182 49.0672 84.3634 47.6796C86.9988 43.7164 87.4893 38.7017 85.6718 34.3029C83.8542 29.9042 79.9671 26.6983 75.3028 25.7512C73.7164 25.4106 72.4754 24.1744 72.1288 22.5894C71.1431 18.519 68.1472 15.2339 64.1847 13.8783C60.2222 12.5227 55.8419 13.2844 52.5696 15.8981V15.9185Z",
    stroke: "#374151",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M50 16.8213V83.1745",
    stroke: "#374151",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M62.2551 66.3401C62.2551 61.8279 65.913 58.17 70.4252 58.17",
    stroke: "url(#paint0_linear_2310_1749)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M37.745 33.6599C37.745 38.1721 34.0872 41.8299 29.575 41.8299",
    stroke: "url(#paint1_linear_2310_1749)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M37.745 66.3401C37.745 61.8279 34.0872 58.17 29.575 58.17",
    stroke: "url(#paint2_linear_2310_1749)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M62.2551 33.6599C62.2551 38.1721 65.913 41.8299 70.4252 41.8299",
    stroke: "url(#paint3_linear_2310_1749)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2310_1749",
    x1: 66.3402,
    y1: 58.17,
    x2: 66.3402,
    y2: 66.3401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2310_1749",
    x1: 33.66,
    y1: 33.6599,
    x2: 33.66,
    y2: 41.8299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2310_1749",
    x1: 33.66,
    y1: 58.17,
    x2: 33.66,
    y2: 66.3401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2310_1749",
    x1: 66.3402,
    y1: 33.6599,
    x2: 66.3402,
    y2: 41.8299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainImage);
export default __webpack_public_path__ + "static/media/brainImage.42e7f7123e87fb90d9f623889c6522dd.svg";
export { ForwardRef as ReactComponent };